<div class="periodontograma-detalle">
  <app-periodontograma-chart
    [estado]="estado"
    [odontogramaEstado]="odontogramaEstado"
    [denticion]="denticion"
    [mode]="'readonly'"
  ></app-periodontograma-chart>
  <div class="leyenda-perio">
    <span class="item"><span class="swatch" [style.background]="configService.config.colores.sangrado"></span>Sangrado</span>
    <span class="item"><span class="swatch" [style.background]="configService.config.colores.supuracion"></span>Supuración</span>
    <span class="item"><span class="swatch" [style.background]="configService.config.colores.placa"></span>Placa</span>
    <span class="item"><span class="swatch" style="background:#e53935"></span>Margen gingival</span>
    <span class="item"><span class="swatch" style="background:#1976d2"></span>Fondo de bolsa</span>
    <span class="item"><span class="swatch" style="background:#bbdefb"></span>Bolsa</span>
    <span class="item"><span class="swatch swatch-cej"></span>CEJ (0)</span>
  </div>
</div>
